import { defineMessages } from 'react-intl';

export default defineMessages({
  voidedShipmentsExpanderTitle: {
    defaultMessage: 'Voided Shipments ({count})',
    description: 'Title for a section that shows voided shipments',
    id: 'ET67o1',
  },
});
